import React, { useState } from 'react';
import PasswordGate from '../components/marketing/PasswordGate';
import MarketingHub from '../components/marketing/MarketingHub';

const KEY = 'jl_marketing_unlocked';

export default function MarketingPage() {
  const [unlocked, setUnlocked] = useState(
    () => true
  );

  const handleUnlock = () => {
    sessionStorage.setItem(KEY, '1');
    setUnlocked(true);
  };

  const handleLock = () => {
    sessionStorage.removeItem(KEY);
    setUnlocked(true);
  };

  return (
    <main className="min-h-screen bg-white text-[#0b1423]">
      {unlocked ? (
        <MarketingHub onLock={handleLock} />
      ) : (
        <PasswordGate onUnlock={handleUnlock} />
      )}
    </main>
  );
}